/*
 * @Author: Gaho
 * @Date: 2024-02-21 15:11:14
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-03 13:22:55
 * @Description: 
 */
import {
    type NewCurrency,
} from './dto/index';

export const useHome = () => {
    // 获取最近的最佳赢钱数据
    const EMIT_GETRECENTTOPWINS = (
        data: {},
        callback: any,
    ) => {
        socket.emit(`gamehistory.getRecentTopWins`, data, callback);
    };

    /**
     * 接收最新的币种设定值（当前用户可能在其它页其它浏览器切换了币种） 
     * @param callback 
     */
    const ON_UPDATE_CURRENCY = (
        callback: (data: NewCurrency) => any,
    ) => {
        socket.on(`updateCurrency`, callback);
    };

    // 开启订阅allbets实时推送
    const EMIT_SUBSCRIBE_MAIN_HISTORY = (
        data: {},
        callback: any
    ) => {
        socket.emit(`profile.subscribeMainHistory`, data, callback);
    }
    // 关闭订阅allbets实时推送
    const EMIT_UNSUBSCRIBE_MAIN_HISTORY = (
        data: {},
        callback: any
    ) => {
        socket.emit(`profile.unsubscribeMainHistory`, data, callback);
    }
    return {
        EMIT_GETRECENTTOPWINS,
        EMIT_SUBSCRIBE_MAIN_HISTORY,
        EMIT_UNSUBSCRIBE_MAIN_HISTORY,
        ON_UPDATE_CURRENCY,
    }
}
